(function () {
  'use strict';
  var loaded = false;
  var resetting = false;

  function allowed() {
    var cmp = window.Consentmo;
    return !!(cmp && typeof cmp.analyticsAllowed === 'function' && typeof cmp.marketingAllowed === 'function'
      && cmp.analyticsAllowed() === true && cmp.marketingAllowed() === true);
  }

  // Outside the consent regions Consentmo fires consentmoSignal_onLoad before window.Consentmo exists and
  // sends no later signal, so re-check once the API appears (bounded: 240 x 250 ms).
  var waiting = false;
  function waitForConsentmo() {
    if (waiting || window.Consentmo || typeof window.setInterval !== 'function') return;
    waiting = true;
    var tries = 0;
    var id = window.setInterval(function () {
      tries += 1;
      if (!window.Consentmo && tries < 240) return;
      window.clearInterval(id);
      waiting = false;
      if (window.Consentmo) update();
    }, 250);
  }

  function update() {
    if (!window.Consentmo) {
      waitForConsentmo();
      return;
    }
    if (!allowed()) {
      if (loaded && !resetting) {
        resetting = true;
        window.location.reload();
      }
      return;
    }
    if (loaded || resetting) return;
    loaded = true;
    var queue = window._talkableq = window._talkableq || [];
    var customer = document.getElementById('consentmo-talkable-customer');
    if (customer) {
      try { queue.push(['authenticate_customer', JSON.parse(customer.textContent)]); } catch (error) {}
    }
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://d2jjzw81hqbuqv.cloudfront.net/integration/clients/renuebyscience.min.js';
    document.head.appendChild(script);
  }

  document.addEventListener('consentmoSignal_onLoad', update);
  document.addEventListener('consentmoSignal', update);
  update();
})();
